import logo from '../LogoMobile.png';
import logoEvent from 'src/assets/images/event/logoEventMobile.webp';

export const LogoMobile = ({
  className,
  onClick,
  role
}: {
  className: string;
  onClick?: () => void;
  role?: string;
}) => {
  const isEventActive = false;

  return (
    <img
      src={isEventActive ? logoEvent : logo}
      className={className}
      alt="logo mobile"
      onClick={onClick}
      role={role}
    />
  );
};
